
































import Vue from 'vue'
import CDragScroll from '~/components/shared/configurable/CDragScroll.vue'
import CImageViewer from '~/components/shared/configurable/image/CImageViewer.vue'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { CLASSIFIED_VIEW_NS } from '~/store/modules/shared/classifieds/view/state'
import {
  REMOVE_PROCESSED_PHOTO,
  SET_BIG_PHOTOS_VISIBLE
} from '~/store/modules/shared/classifieds/view/mutation-types'
import CCarouselThumb from '~/components/shared/configurable/image/carousel/CCarouselThumb.vue'
import CCard from '~/components/shared/configurable/card/CCard.vue'
export default Vue.extend({
  components: { CCarouselThumb, CCard, CDragScroll, CImageViewer },
  props: {
    classified: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedIndex: 0,
      showZoomer: false,
      canClickThumbs: true
    }
  },
  computed: {
    ...mapState({
      bigPhotosVisible: state => state.classifieds.view.bigPhotosVisible
    }),
    ...mapGetters(CLASSIFIED_VIEW_NS, {
      processedPhotos: 'processedPhotos'
    }),
    youtube() {
      if (this.classified.videos.length) {
        return 'https://www.youtube.com/embed/' + this.classified.videos[0].url
      }

      return null
    },
    filesToShow() {
      return this.processedPhotos.map(f => {
        return {
          type: f.type,
          url: f.big,
          name: f.name || null
        }
      })
    }
  },
  watch: {
    bigPhotosVisible(value) {
      if (value === true) {
        this.imageClicked(0)
      }
    }
  },
  mounted() {},
  methods: {
    ...mapMutations(CLASSIFIED_VIEW_NS, {
      setBigPhotosVisible: SET_BIG_PHOTOS_VISIBLE,
      removeProcessedPhoto: REMOVE_PROCESSED_PHOTO
    }),
    imageClicked(index) {
      if (!this.canClickThumbs) {
        return
      }
      this.selectedIndex = index

      if (this.thumbIsShown(index)) {
        this.showZoomer = true
      }

      const scroller = this.$refs.scroller
      if (scroller) {
        scroller.setActiveChildIndex(index)
      }
    },
    onZoomerClose() {
      this.showZoomer = false
      this.setBigPhotosVisible(false)
    },
    thumbIsShown(index) {
      const scroller = this.$refs.scroller
      if (scroller) {
        return scroller.childIsVisible(index)
      }
      return true
    }
  }
})
